@if (!posterLoadingFailed) {
  <div (click)="play()" class="ziggeo-player-container">
    @if (!playing || !canPlay) {
      <div class="poster-container">
        <img [src]="posterUrl" (error)="onPosterLoadError()" class="poster" />
        <div class="playbutton-container">
          @if (!playing) {
            <div class="playbutton"></div>
          }
          @if (playing && !canPlay) {
            <rt-spinner layout-centered> </rt-spinner>
          }
        </div>
      </div>
    }
    @if (playing && !posterLoadingFailed) {
      <video
        (canplay)="onCanPlay()"
        width="100%"
        height="auto"
        controls
        controlsList="nodownload"
        autoplay
        [class.video-hidden]="!canPlay"
      >
        <source [src]="videoUrl + '.mp4'" type="video/mp4" />
        <source [src]="videoUrl + '.ogg'" type="video/ogg" />
      </video>
    }
  </div>
}
@if (posterLoadingFailed) {
  <div class="error-message">
    {{ noAnswer }}
  </div>
}
